import * as React from 'react';
import classnames from 'classnames';

import { AppPicture } from '@src/services/app/components/AppPicture/AppPicture';

export interface PracticesProps {
  className?: string;
}

/**
 * @name Practices
 * @description Component rendering Haldi's sustainability practices.
 */
export const Practices = (props: PracticesProps) => {
  const { className } = props;

  return (
    <div
      className={classnames('flex flex-col p-10 md:mb-6x lg:px-10x', className)}
    >
      <div className="pb-6 text-center">
        <h1 className="md:text-5xl md:leading-relaxed">
          Our sustainability practices
        </h1>
      </div>
      <div className="flex flex-col gap-4 md:gap-12">
        <div className="flex flex-col md:flex-row md:gap-8">
          <div className="md:flex md:w-2/4 md:gap-8">
            <div>
              <h3 className="mb-0 font-bold">1</h3>
            </div>
            <div>
              <h3 className="font-bold">
                Personal recommendations that will work for you
              </h3>
              <div className="h-1 w-16 bg-pine"></div>
              <p className="mt-4">
                We only recommend products that have a high chance of working
                for you, to break you out of the endless cycle of trial and
                error. This leads to less unused product sitting on bathroom
                shelves and significantly lower returns. Overall less landfill!
              </p>
            </div>
          </div>
          <div className="md:flex md:w-2/4 md:gap-8">
            <div>
              <h3 className="mb-0 font-bold">2</h3>
            </div>
            <div>
              <h3 className="font-bold">All sizes available</h3>
              <div className="h-1 w-16 bg-rust"></div>
              <p className="mt-4">
                We want you to buy the size that is right for you at that
                moment, not the largest size to maximize our sales. So we carry
                all available sizes of a product, from minis to jumbos. If you
                are checking out a product for the 1st time, maybe start with
                the mini. And if you are in love with a product, go for the full
                size/jumbo. By right-sizing our purchase, we all can play a
                part.
              </p>
            </div>
          </div>
        </div>
        <div className="flex flex-col bg-seaSaltLight p-4 md:flex-row md:gap-8">
          <div className="md:flex md:w-2/4 md:p-8">
            <div>
              <h3 className="mt-0 font-bold">3</h3>
            </div>
            <div className="md:p-4 md:pt-0">
              <h3 className="font-bold md:mt-0">Keep using what you have</h3>
              <div className="h-1 w-16 bg-turmeric"></div>
              <p className="mt-4">
                You have products you bought elsewhere which are still half
                full, we would never ask you to toss them and start from
                scratch. It's just too wasteful. We only recommend products for
                gaps in your routine, stuff you really need. Overall less
                consumption, even if it means less sales for us.
              </p>
            </div>
          </div>
          <div className="flex items-center justify-center pt-8 md:w-2/4">
            <AppPicture
              className="max-h-[375px]"
              png="/images/png/moisturizer.png"
            />
          </div>
        </div>
        <div className="flex flex-col md:flex-row md:gap-8">
          <div className="md:flex md:w-2/4 md:gap-8">
            <div>
              <h3 className="mb-0 font-bold">4</h3>
            </div>
            <div>
              <h3 className="font-bold">Personalized samples</h3>
              <div className="h-1 w-16 bg-pine"></div>
              <p className="mt-4">
                Samples are a great way to get to know a product before you buy.
                But samples lead to a ton of waste with boxes being stuffed with
                samples, you will never use. So we even personalize our samples,
                any sample you receive has a high chance of working for you, so
                you can try without the waste.
              </p>
            </div>
          </div>
          <div className="md:flex md:w-2/4 md:gap-8">
            <div>
              <h3 className="mb-0 font-bold">5</h3>
            </div>
            <div>
              <h3 className="font-bold">Behind the scenes geeky stuff</h3>
              <div className="h-1 w-16 bg-forest"></div>
              <p className="mt-4">
                A lot of industry waste happens with retailers sending unsold
                inventory back to brands; expired or discontinued products, all
                of which land up in landfill. We've built a data science backed
                inventory management system, which significantly reduces expired
                products or unsold inventory. Bottom line, less landfill.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
